module.exports = __webpack_public_path__ + "1dc0b55520822e2a92300460fd395bac.png";